import { IS_PAID_USER, platform } from 'reactApp/appHelpers/configHelpers';
import { sendDwh, sendXray } from 'reactApp/utils/ga';

type Actions =
    | 'show'
    | 'click'
    | 'close'
    | 'click-tariff'
    | 'click-info'
    | 'view'
    | 'icon-info'
    | 'switcher'
    | 'block-view'
    | 'block-click';

type Ttypes =
    | 'modal'
    | 'dialog'
    | 'button'
    | 'balloon'
    | 'tooltip'
    | 'tariffs-quota'
    | 'banner'
    | 'button-info'
    | 'icon-info'
    | 'union-quota'
    | 'object';

interface RadarArgs {
    action?: Actions;
    name?: string | null;
    button_name?: string;
    source?: string;
    place?: string;
    data?: Record<string, string | number | boolean>;
}

export const sendDwhRadar = ({ action = 'show', name = '', data, button_name, t = 'modal', place, source }: RadarArgs & { t?: Ttypes }) => {
    const bttnName = button_name ? `${button_name}` : '';
    sendXray([`dwh_${t}`, name ?? 'nn', action, bttnName, platform]);

    sendDwh({
        eventCategory: t,
        action,
        dwhData: {
            name,
            paid_user: IS_PAID_USER,
            platform,
            button_name,
            place,
            source,
            ...data,
        },
    });
};

export const sendDwhModal = ({ action = 'show', name, data, button_name, place }: RadarArgs) =>
    sendDwhRadar({
        action,
        name,
        data,
        button_name,
        place,
        t: 'modal',
    });

export const sendDwhDialog = ({ action = 'show', name, data, button_name, place }: RadarArgs) =>
    sendDwhRadar({
        action,
        name,
        data,
        button_name,
        place,
        t: 'dialog',
    });

export const sendDwhButton = ({ action = 'show', name, data, source }: RadarArgs) =>
    sendDwhRadar({
        action,
        name,
        data,
        source,
        t: 'button',
    });

export const sendDwhTooltip = ({ action = 'show', name, data, place, button_name }: RadarArgs) =>
    sendDwhRadar({
        action,
        name,
        data,
        button_name,
        place,
        t: 'tooltip',
    });

export const sendDwhBanner = ({ action = 'show', name, data, place, button_name }: RadarArgs) =>
    sendDwhRadar({
        action,
        name,
        data,
        button_name,
        place,
        t: 'banner',
    });
